import * as stylex from '@stylexjs/stylex';
import '@tokens/colors.stylex';
import { colors } from '@tokens/colors.stylex';
import '@tokens/spacing.stylex';
import { spacing } from '@tokens/spacing.stylex';
import '@tokens/typography.stylex';
import { typography } from '@tokens/typography.stylex';

// Ported 1:1 from the prototype `.lbl` — the uppercase eyebrow label used in edit forms.
export const styles = {
  lbl: {
    k1xSpc: "x1lliihq",
    kMv6JI: "xpc6l4x",
    kGuDYH: "x1j6dyjg",
    k63SB2: "xomqrzn",
    kb6lSQ: "x1dgsrnt",
    kP9fke: "xtvhhri",
    kMwMTN: "xdxw5r1",
    k1K539: "x41b47z",
    $$css: true
  }
};